import React, { Component } from "react";
import { connect } from "react-redux";
import { actualizarMensaje, mostrarModulo } from "../../redux/actions/actGlobal";
import { withStyles } from '@material-ui/core/styles';
import { obtenerValoresFiltros } from "../../global/js/funciones";
import Procesos from "./Procesos";
import Administrar from "./Administrar";
import NuevoAdministrar from "./NuevoAdministrar";
import { MenuAdministrar } from "./MenuAcompanamiento";
import {ESTADO} from "./helper"

const styles = (theme) => ({
  container: {
    padding: '20px',
    maxWidth: '1200px',
    margin: '0 auto',
    width: '95%'
  }
});

class AcompanamientoAdministrar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "procesos",
      periodo: ''
    };
  }

  async componentDidMount() {
    const { mostrarModulo } = this.props;
    mostrarModulo({ ruta: "/acompanamiento_administrar", nombre: "Acompañamiento Administar" });
    await this.obtenerPeriodo();
  }

  obtenerPeriodo = async () => {
    let periodo = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Per_Acomo_docen_Sol' }, { 'llave': 'estado', 'valor': ESTADO }]);
    this.setState({ periodo: periodo.length > 0 ? periodo[0].nombre : '' });
  }

  actualizarPeriodo = (nuevoPeriodo) => {
    this.setState({ periodo: nuevoPeriodo });
  }

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  }

  render() {
    const { classes } = this.props;
    const { activeTab } = this.state;

    return (
      <div>
        <MenuAdministrar 
          sele={activeTab} 
          seleccionar={this.handleTabChange} 
        />
        <div className="contenido_modulo">
          <div className={classes.container}>
            {activeTab === "procesos" && <Procesos periodo={this.state.periodo} />}
            {activeTab === "administrar" && <Administrar periodo={this.state.periodo} actualizarPeriodo={this.actualizarPeriodo} />}
            {activeTab === "nuevo" && <NuevoAdministrar />}
          </div>
        </div>
      </div>
    );
  }
}

// CARGO ESTADOS DEL MODULO (por ahora vacío si no usas nada del store)
const mapStateToProps = () => ({});

const mapDispatchToProps = {
  actualizarMensaje,
  mostrarModulo
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AcompanamientoAdministrar));
